import React, {Component} from 'react'
import Spinner from "../../../../../components/Spinnner/Spinner";
import Pagination from "../../../../../components/DashboardComponents/Pagination";
import FontAwesomeComponent, {RemoveFontAwesome, SortIcon} from "../../../../../components/FontAwesomeComponent";
import classes from '../../Artists/styles/artist.module.css'
import queryString from 'query-string';
import {Link, NavLink} from "react-router-dom";
import {ModalView} from "../../../../../components/BootstrapModal";
import * as actions from '../../../../../layouts/RootLayout/rootLayout.reducer'
import {connect} from 'react-redux'
import {ResetCMSButton, SearchCMSComponent, SubmitCMSButton} from "../../../../../components/CMSFormComponents";
import UserAdminService from "../../../../../services/UserAdminService";

class Users extends Component{

    state = {
        entities: [],
        page: 0,
        sortField: 'id',
        sortOrder: 'asc',
        totalPages: 0,
        noEntity: false,
        deleteEntity: {id: -1, deleteEntityName: ''},
        // NAME
        usernameInputValue: '',
        username: ''
    }

    componentDidMount() {
        let params = queryString.parse(this.props.location.search);
        if(JSON.stringify(params) !== '{}'){
            let tempState = {};
            if(params.username){
                tempState.username = params.username;
            }
            if(params.sort){
                const values = params.sort.split(",");
                tempState.sortField = values[0];
                tempState.sortOrder = values[1];
            }
            if(params.page){
                tempState.page = +params.page;
            }
            this.setState(tempState);
            if(tempState.page === 0 ) this.getEntities()
        } else {
            this.getEntities();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevState.page !== this.state.page || prevState.sortField !== this.state.sortField || prevState.sortOrder !== this.state.sortOrder || prevState.username !== this.state.username){
            this.getEntities();
            let url = `${this.props.location.pathname}?page=${this.state.page}&sort=${this.state.sortField},${this.state.sortOrder}`;
            url += this.state.username && this.state.username !== '' ? `&username=${this.state.username}`: '';
            this.props.history.push(url);
        }
    }

    getEntities = () => {
        this.setState({noEntity: false})
        UserAdminService.getPagedUsers({page: this.state.page, sortField: this.state.sortField, sortOrder: this.state.sortOrder, username: this.state.username}).then(
            res => {
                this.setState({entities: [...res.data.content], totalPages: res.data.totalPages, noEntity: res.data.content.length === 0 ? true : false});
            }
        );
    }

    handlePageClick = ({selected}) => {
        this.setState({page: selected});
    }

    onSearchHandler = (event) => {
        if(event) event.preventDefault();
        this.setState({page: 0, username: this.state.usernameInputValue});
    }

    onResetSearchHandler = (event) => {
        if(event) event.preventDefault();
        this.setState({page: 0, sortField: 'id', sortOrder: 'asc', usernameInputValue: '', username: ''});
    }

    sortByHandler = (field) => {
        if(this.state.sortField === field){
            this.setState({sortOrder: this.state.sortOrder === 'asc' ? 'desc' : 'asc', page : 0});
        } else {
            this.setState({sortField: field, sortOrder: 'asc', page: 0});
        }
    }

    gotoAddNewEntityPage = () => {
        this.props.history.push("/dashboard/users/new");
    }

    deleteEntity = (id) => {
        UserAdminService.deleteUser(id).then(
            (res) => {
                this.props.sucessToast("Successfully Deleted " + res.data.username)
                this.getEntities();
            }
        ).catch((err) => {
            this.props.errorToast("Something went wrong")
        })
    }

    TopToolbar = () => {
        return (<>
                <button onClick={this.gotoAddNewEntityPage} className="btn btn-primary float-right"><FontAwesomeComponent name="fa-plus-circle"/> Add New User</button>
                <div style={{display: "flex", justifyContent: "center", flexWrap: "wrap", clear: "both"}}>
                    <SearchCMSComponent title="Username" searchText={this.state.usernameInputValue} fieldName={"username"} setSearchText={(value) => this.setState({usernameInputValue: value})} entityServiceSearchCall={UserAdminService.searchForUsersByUsername}/>
                </div>
                <div style={{display: "flex", justifyContent: "center", marginBottom: "10px"}}>
                    <SubmitCMSButton onSearch={this.onSearchHandler}/>
                    <ResetCMSButton onResetSearch={this.onResetSearchHandler}/>
                </div>
            </>
        );
    }

    render() {

        if(this.state.entities.length === 0 && this.state.noEntity){
            return (
                <>
                    {this.TopToolbar()}
                    <div className="card" style={{width: "80%", textAlign: "center", margin: "0 auto", maxWidth: "600px"}}>
                        <div className="card-body">
                            <h5 className="card-title">No Such Item Found</h5>
                            <button onClick={this.onResetSearchHandler} className="btn btn-primary">Reset</button>
                        </div>
                    </div>
                </>
            )
        }

        if(this.state.entities.length == 0){
            return (
                <Spinner/>
            );
        }

        return (
            <>
                {this.TopToolbar()}
                <Pagination handlePageClick={this.handlePageClick} totalPages={this.state.totalPages} currentPage={this.state.page}/>
                <table className="table table-hover">
                    <thead>
                    <tr>
                        <th onClick={this.sortByHandler.bind(this, 'id')} className={classes.clickableTableHeader} style={this.state.sortField === 'id' ? {backgroundColor: "#ccc"}: null} scope="col"># <SortIcon/></th>
                        <th onClick={this.sortByHandler.bind(this, 'username')} className={classes.clickableTableHeader} style={this.state.sortField === 'username' ? {backgroundColor: "#ccc"}: null} scope="col">Manufacturer <SortIcon/></th>
                        <th onClick={this.sortByHandler.bind(this, 'firstName')} className={classes.clickableTableHeader} style={this.state.sortField === 'firstName' ? {backgroundColor: "#ccc"}: null} scope="col">First Name <SortIcon/></th>
                        <th onClick={this.sortByHandler.bind(this, 'lastName')} className={classes.clickableTableHeader} style={this.state.sortField === 'lastName' ? {backgroundColor: "#ccc"}: null} scope="col">Last Name <SortIcon/></th>
                        <th onClick={this.sortByHandler.bind(this, 'phoneNumber')} className={classes.clickableTableHeader} style={this.state.sortField === 'phoneNumber' ? {backgroundColor: "#ccc"}: null} scope="col">Phone Number <SortIcon/></th>
                        <th onClick={this.sortByHandler.bind(this, 'enabled')} className={classes.clickableTableHeader} style={this.state.sortField === 'disabled' ? {backgroundColor: "#ccc"}: null} scope="col">Status <SortIcon/></th>
                        <th scope="col"></th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        this.state.entities.map(entity => {
                            return (
                                <tr key={entity.id}>
                                    <th>{entity.id}</th>
                                    <td>{entity.username}</td>
                                    <td>{entity.firstName}</td>
                                    <td>{entity.lastName}</td>
                                    <td>{entity.phoneNumber}</td>
                                    <td>{entity.enabled ? <span className="badge badge-primary">Enabled</span> : <span className="badge badge-danger">Disabled</span>}</td>
                                    <td style={{display: "flex", justifyContent: "space-around"}}>
                                        <Link to={`${this.props.match.url}/${entity.id}`}><button className="btn btn-primary">Views</button></Link>
                                        <Link to={`${this.props.match.url}/${entity.id}/edit`}><button className="btn btn-warning">Edit</button></Link>
                                        <button onClick={() => this.setState({deleteEntity: {id: entity.id, username: entity.username}})} className="btn btn-danger" data-toggle="modal" data-target="#customModal">Remove</button>
                                    </td>
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </table>
                <ModalView title={`Delete ${this.state.deleteEntity.username}`} id={this.state.deleteEntity.id} body={`Are you sure you want to remove [${this.state.deleteEntity.id}] ${this.state.deleteEntity.name}?`} callback={this.deleteEntity} confirmLabel={<><RemoveFontAwesome/> Delete</>} buttonTheme="btn-danger"/>
            </>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        sucessToast: (message) => dispatch(actions.sucessToast(message)),
        errorToast: (message) => dispatch(actions.errorToast(message))
    }
}

export default connect(null, mapDispatchToProps)(Users);

